import { api } from "@/lib/api/client";

import type {
  Notification,
  NotificationListResponse,
  UnreadCountResponse,
} from "./types";

interface ListParams {
  page?: number;
}

export const notificationsApi = {
  list: async (params: ListParams = {}): Promise<NotificationListResponse> => {
    const { data } = await api.get<NotificationListResponse>("/notifications/", { params });
    return data;
  },
  unreadCount: async (): Promise<UnreadCountResponse> => {
    const { data } = await api.get<UnreadCountResponse>("/notifications/unread-count/");
    return data;
  },
  markRead: async (id: string): Promise<Notification> => {
    const { data } = await api.post<Notification>(`/notifications/${id}/mark-read/`);
    return data;
  },
  markAllRead: async (): Promise<void> => {
    await api.post("/notifications/mark-all-read/");
  },
};
